import gql from 'graphql-tag';

export const SEARCH_SHARES = gql`
  query searchShares($idValue: ID!) {
    SearchShares(id:$idValue) {
      id
    }
  }
`;

export const CREATE_SHARE = gql`
  mutation createShare(
    $id: ID,
    $percent: Float,
    $validityStartDate: _Neo4jDateInput,
    $validityEndDate: _Neo4jDateInput,
    $type: String,
    $territoryCode: [String],
    $useType: String,
    $carrierType: String,
    $commercialModelType: String,
    $rightsInDispute: String,
    $rightsClaimPolicyCondition: String,
    $rightsClaimPolicyType: String,
    $originalPublisherShare: String,
    $isFollowerInTitleOf: String,
    $rightsShareUnknown: Boolean,
    $rightsShareNotClaimed: Boolean,
    $value: Float,
    $unit: String
  ){
  CreateShare(
    id: $id,
    percent: $percent,
    validityStartDate: $validityStartDate,
    validityEndDate: $validityEndDate,
    type: $type,
    territoryCode: $territoryCode,
    useType: $useType,
    carrierType: $carrierType,
    commercialModelType: $commercialModelType,
    rightsInDispute: $rightsInDispute,
    rightsClaimPolicyCondition: $rightsClaimPolicyCondition,
    rightsClaimPolicyType: $rightsClaimPolicyType,
    originalPublisherShare: $originalPublisherShare,
    isFollowerInTitleOf: $isFollowerInTitleOf,
    rightsShareUnknown: $rightsShareUnknown,
    rightsShareNotClaimed: $rightsShareNotClaimed,
    value: $value,
    unit: $unit
  ) {
    id,
    percent,
    validityStartDate { formatted },
    validityEndDate { formatted },
    type,
    territoryCode,
    useType,
    carrierType,
    commercialModelType,
    rightsInDispute,
    rightsClaimPolicyCondition,
    rightsClaimPolicyType,
    originalPublisherShare,
    isFollowerInTitleOf,
    rightsShareUnknown,
    rightsShareNotClaimed,
    value,
    unit
  }
}
`;

export const UPDATE_SHARE = gql`
  mutation updateShare(
    $id: ID!,
    $percent: Float,
    $validityStartDate: _Neo4jDateInput,
    $validityEndDate: _Neo4jDateInput,
    $type: String,
    $territoryCode: [String],
    $useType: String,
    $carrierType: String,
    $commercialModelType: String,
    $rightsInDispute: String,
    $rightsClaimPolicyCondition: String,
    $rightsClaimPolicyType: String,
    $originalPublisherShare: String,
    $isFollowerInTitleOf: String,
    $rightsShareUnknown: Boolean,
    $rightsShareNotClaimed: Boolean,
    $value: Float,
    $unit: String
  ){
  UpdateShare(
    id: $id,
    percent: $percent,
    validityStartDate: $validityStartDate,
    validityEndDate: $validityEndDate,
    type: $type,
    territoryCode: $territoryCode,
    useType: $useType,
    carrierType: $carrierType,
    commercialModelType: $commercialModelType,
    rightsInDispute: $rightsInDispute,
    rightsClaimPolicyCondition: $rightsClaimPolicyCondition,
    rightsClaimPolicyType: $rightsClaimPolicyType,
    originalPublisherShare: $originalPublisherShare,
    isFollowerInTitleOf: $isFollowerInTitleOf,
    rightsShareUnknown: $rightsShareUnknown,
    rightsShareNotClaimed: $rightsShareNotClaimed,
    value: $value,
    unit: $unit
  ) {
    id,
    percent,
    validityStartDate { formatted },
    validityEndDate { formatted },
    type,
    territoryCode,
    useType,
    carrierType,
    commercialModelType,
    rightsInDispute,
    rightsClaimPolicyCondition,
    rightsClaimPolicyType,
    originalPublisherShare,
    isFollowerInTitleOf,
    rightsShareUnknown,
    rightsShareNotClaimed,
    value,
    unit
  }
}
`;

export const DELETE_SHARE = gql`
  mutation deleteShare (
    $id: ID!
  ) {
  DeleteShare(
    id: $id
  ) {
    id
  }
}
`;
// AddShareWork(from: _ShareInput!, to: _WorkInput!): _AddShareWorkPayload
// RemoveShareWork(from: _ShareInput!, to: _WorkInput!): _RemoveShareWorkPayload
// AddShareFor(from: _ShareInput!, to: _ContributionInput!): _AddShareForPayload
// RemoveShareFor(
//   from: _ShareInput!
//   to: _ContributionInput!
// ): _RemoveShareForPayload
